var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9853)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9853)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79246 20.084C3.32077 20.6596 3.95617 20.9474 4.69865 20.9474H9.83895V16.1405H10.3479C10.4358 13.8623 11.4591 11.8475 13.0102 10.5403H11.5524V8.67359H13.2658V10.335C14.0586 9.72846 14.9744 9.29993 15.9645 9.10278V4.94011C15.9645 4.13119 15.7003 3.43894 15.172 2.86337C14.6437 2.28779 14.0083 2 13.2658 2H8.12552C7.38303 2 6.74763 2.28779 6.21933 2.86337C5.69102 3.43894 5.42686 4.13119 5.42686 4.94011V5.73347H4.69865C3.95617 5.73347 3.32077 6.02126 2.79246 6.59684C2.26415 7.17242 2 7.86467 2 8.67359V18.0073C2 18.8162 2.26415 19.5084 2.79246 20.084ZM11.7143 20.9474C11.6589 20.867 11.6049 20.7853 11.5524 20.7024V20.9474H11.7143ZM6.41209 18.0073H4.69865V16.1405H6.41209V18.0073ZM6.41209 14.2738H4.69865V12.4071H6.41209V14.2738ZM6.41209 10.5403H4.69865V8.67359H6.41209V10.5403ZM9.83895 14.2738H8.12552V12.4071H9.83895V14.2738ZM9.83895 10.5403H8.12552V8.67359H9.83895V10.5403ZM9.83895 6.80685H8.12552V4.94011H9.83895V6.80685ZM13.2658 6.80685H11.5524V4.94011H13.2658V6.80685Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3487 21.9999L16.0589 20.421C15.8656 20.3333 15.6843 20.2414 15.5149 20.1452C15.3461 20.0484 15.1732 19.9298 14.9961 19.7894L13.5951 20.2631L12.6289 18.4736L13.74 17.421C13.7078 17.1754 13.6917 16.9473 13.6917 16.7368C13.6917 16.5263 13.7078 16.2982 13.74 16.0526L12.6289 14.9999L13.5951 13.2105L14.9961 13.6842C15.1732 13.5438 15.3461 13.4252 15.5149 13.3284C15.6843 13.2322 15.8656 13.1403 16.0589 13.0526L16.3487 11.4736H18.2811L18.5709 13.0526C18.7642 13.1403 18.9455 13.2368 19.1149 13.3421C19.2837 13.4473 19.4566 13.5789 19.6337 13.7368L21.0347 13.2105L22.0009 15.0526L20.8898 16.1052C20.922 16.3157 20.9381 16.535 20.9381 16.7631C20.9381 16.9912 20.922 17.2105 20.8898 17.421L22.0009 18.4736L21.0347 20.2631L19.6337 19.7894C19.4566 19.9298 19.2837 20.0484 19.1149 20.1452C18.9455 20.2414 18.7642 20.3333 18.5709 20.421L18.2811 21.9999H16.3487ZM17.3149 18.8421C17.8463 18.8421 18.3014 18.6361 18.6801 18.2242C19.0582 17.8115 19.2473 17.3157 19.2473 16.7368C19.2473 16.1578 19.0582 15.6621 18.6801 15.2494C18.3014 14.8375 17.8463 14.6315 17.3149 14.6315C16.7835 14.6315 16.3287 14.8375 15.9506 15.2494C15.5719 15.6621 15.3825 16.1578 15.3825 16.7368C15.3825 17.3157 15.5719 17.8115 15.9506 18.2242C16.3287 18.6361 16.7835 18.8421 17.3149 18.8421Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageClients);
export default __webpack_public_path__ + "static/media/manage_clients.f7b920eafad7f7dbcff857d05946aa40.svg";
export { ForwardRef as ReactComponent };